import React, { memo, useMemo, useState, useEffect } from 'react';
import '@modules/proposal/ProposalBuilderPage/index.scss';
import { useQueryStringParam, useRouteParam } from '@core/router';
import { ProposalsPage } from './ProposalsPage';

export const ViewProposalPage = memo(() => {
  const proposalId = useRouteParam('id');

  return (
    <div id="proposal-builder" style={{ margin: 0 }}>
      <ProposalsPage proposalId={proposalId} />
    </div>
  );
});
